

























// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StoryUser } from '../StoryUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';

@Component({
  name: 'InviteTypeComponent',
  components: { 
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue')
   }
})
export default class InviteTypeComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public invitedSomeone: boolean = false
  public cancelBtnTextIfInvited = 'Done'
  public cancelBtnTextIfNotInvited = 'Cancel'

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading; }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): StoryUser { return this.$store.getters.isAuthenticated }

  public get cancelBtnVariant(): string { return this.invitedSomeone ? 'success' : 'secondary'; }
  public cancelBtnText(): string { return this.invitedSomeone ? this.cancelBtnTextIfInvited : this.cancelBtnTextIfNotInvited }
  public get cancelBtnSize(): string { return this.invitedSomeone ? 'md' : 'sm' }

  public setCancelButtonText(ifInvitedText: string, ifNotInvitedText: string ) { this.cancelBtnTextIfInvited = ifInvitedText; this.cancelBtnTextIfNotInvited = ifNotInvitedText }

  public onChoseInviteListeners() {
    const modalTitle: string = 'Invite To Your Listening Circle';
    (this.$refs.InvitesFormModalComponent as any).show(modalTitle, 'md', { invitedByName: this.user.firstName })
  }

  public onChoseInviteStoryTeller() {
    const modalTitle: string = 'Invite a Storyteller and Their Circle';
    (this.$refs.InvitesFormModalComponentWithStoryTeller as any).show(modalTitle, 'md', { invitedByName: this.user.firstName })
  }  

// e.g. UserCircleComponent.onModalShow(InvitesFormComponent, false, true)
  public async onModalShow(componentName: string, modalShowing: boolean, invitedSomeone: boolean) {
    if (!modalShowing && invitedSomeone) {
      this.invitedSomeone = true
    }
  }

  public onCancel() {
    this.$emit('close', this.invitedSomeone)
  }

  // Parents call this to show modal (use a ref to call child -- https://stackoverflow.com/questions/42632711/how-to-call-function-on-child-component-on-parent-events)
  public async onShow(dynamicProps: { }) {
    if (!dynamicProps) return
  }

// private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }


}
